module.exports = __webpack_public_path__ + "public/adminIcons/contentIcon.svg?336eb14c";